import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { translateApiMessage } from '@/utils/apiMessageI18n.js'
import Cookies from 'js-cookie'
import router from '../router'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 360000,
})
// 登录、验证码等匿名接口不携带旧 token，避免 Jwt 过滤器查 Redis 导致 500/超时
const NO_TOKEN_URLS = [
  '/api/admin/login',
  '/api/admin/validate/code/get',
  '/api/admin/resetpd',
]

function shouldShowErrorMessage (config) {
  return !(config && config.silentError)
}

function showErrorMessage (config, message) {
  if (!shouldShowErrorMessage(config)) return
  Message({
    message: translateApiMessage(message) || 'Error',
    type: 'error',
    duration: 5 * 1000,
  })
}

function handleUnauthorized (code) {
  if (code === 401) {
    router.push('/login')
    Cookies.remove('vue_admin_token')
    localStorage.setItem('buttonPerms', '')
    localStorage.setItem('permName', '')
    localStorage.setItem('clickIndex', 0)
  }
}

// 请求拦截器：携带的token字段
service.interceptors.request.use(
  (config) => {
    const skipToken = NO_TOKEN_URLS.some((path) => config.url && config.url.indexOf(path) > -1)
    if (store.getters.token && !skipToken) {
      config.headers.token = getToken()
    }
    // 辅助 header：后端以 JWT 内 user.timeZoneId 为准，勿信任此 header 做权限或查询
    const accountTimeZone = store.getters.accountTimeZone
    if (accountTimeZone != null && accountTimeZone !== '') {
      config.headers.timeZoneId = accountTimeZone
    }

    if (config.url.indexOf('export/log') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeDebugReport') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebike') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('importEbikeVin') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('importFenceEbike') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('exportFenceLog') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('importEbikeBaseInfo') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('ebikeCertificateConformity/import') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeModel') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('downloadTempFile') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeMaintainRecord') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('export/ebikeSaleRecord') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('fullEbikeCcc') > -1) {
      config.responseType = 'blob'
    }

    if (config.url.indexOf('fullEbikeFactory') > -1) {
      config.responseType = 'blob'
    }

    return config
  },
  (error) => {
    console.log(error) // for debug
    return Promise.reject(error)
  },
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data

    if (response.config.url.indexOf('export/log') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebike') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeDebugReport') > -1) {
      return res
    }

    if (response.config.url.indexOf('importEbikeVin') > -1) {
      return res
    }

    if (response.config.url.indexOf('importFenceEbike') > -1) {
      return res
    }

    if (response.config.url.indexOf('exportFenceLog') > -1) {
      return res
    }

    if (response.config.url.indexOf('importEbikeBaseInfo') > -1) {
      return res
    }

    if (response.config.url.indexOf('ebikeCertificateConformity/import') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeModel') > -1) {
      return res
    }

    if (response.config.url.indexOf('downloadTempFile') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeMaintainRecord') > -1) {
      return res
    }

    if (response.config.url.indexOf('export/ebikeSaleRecord') > -1) {
      return res
    }

    if (response.config.url.indexOf('fullEbikeCcc') > -1) {
      return res
    }

    if (response.config.url.indexOf('fullEbikeFactory') > -1) {
      return res
    }

    if (response.config.url.indexOf('system/api/admin') > -1) {
      if (res.code !== 200) {
        if (response.config.url.indexOf('getAdminInfoByToken') > -1) {
        } else {
          showErrorMessage(response.config, res.message)
        }
        handleUnauthorized(res.code)
        if (response.config.silentError) {
          return res
        }
      } else {
        return res
      }
    } else {
      if (res.result) {
        if (res.result.code !== 200) {
          showErrorMessage(response.config, res.result.errorMsg)
          handleUnauthorized(res.result.code)
          if (response.config.silentError) {
            return res.result
          }
        } else {
          return res.result
        }
      } else {
        if (res.code !== 200) {
          showErrorMessage(response.config, res.message)
          handleUnauthorized(res.code)
          if (response.config.silentError) {
            return res
          }
        } else {
          return res
        }
      }
    }
  },
  (error) => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  },
)

export default service
